/** @format */

import { type HTMLAttributes, type ReactNode } from 'react';

type ContainerProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode;
};

export const Container = (props: ContainerProps) => {
  const { children, ...rest } = props;
  return (
    <div className="container" {...rest}>
      {children}
    </div>
  );
};
